export default "__VITE_ASSET__BH$YYHRr__"